<template>
  <RouterView />
</template>

<script lang="ts" setup>
</script>